import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    CommonModule,
  ],
})
export class LoginComponent implements OnInit {
  ssoErrorMessage = '';
  isSsoLoading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const ssoError = this.route.snapshot.queryParamMap.get('sso_error');
    if (ssoError === 'code_already_used') {
      this.ssoErrorMessage =
        'Your sign-in link expired or was already used. Please sign in again and do not refresh the Microsoft callback page.';
    } else if (ssoError === 'no_admin_access') {
      this.ssoErrorMessage =
        'Your account does not have access to the Admin Tool. Please contact your administrator to assign a role and permissions.';
    } else if (ssoError === 'login_failed') {
      this.ssoErrorMessage =
        'Sign-in failed. Please try again. If this continues, contact your administrator.';
    } else if (ssoError) {
      this.ssoErrorMessage =
        'Sign-in failed. Please try again. If this continues, contact your administrator.';
    }
  }

  login(): void {
    if (this.isSsoLoading) {
      return;
    }
    this.isSsoLoading = true;
    this.authService.login();
  }
}

